export type ArgumentsMap = { [key: string]: string };

export const getArgumentsMapVariables = (args: ArgumentsMap) => {
  return Object.keys(args).map((k) => `$${k}: ${args[k]}`);
};
export const getArgumentsMapAttributes = (args: ArgumentsMap) => {
  return Object.keys(args).map((k) => `${k}: $${k}`);
};
